// Vayu: one-tap add-ons in the cart drawer / cart page (snippets/vayu-cart-addons.liquid).
// Adds the variant, then tells Horizon's cart components to re-render via the standard
// cart lines-update event, so the drawer, totals, perks bar and cart bubble all refresh.
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__vayuAddonsInit) {
  window.__vayuAddonsInit = true;

  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-vayu-addon]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    let dispatched = false;

    try {
      button.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: variantId, quantity: 1 }],
          promise: deferred.promise,
        })
      );
      dispatched = true;
    } catch (e) {
      console.warn('[vayu-addons] could not dispatch cart event', e);
    }

    try {
      const addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Add to cart failed');

      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();

      if (dispatched && sectionIds.length) {
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'vayu-cart-addons',
            itemCount: 1,
            sections: data.sections,
            didError: false,
          },
        });
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.warn('[vayu-addons]', error);
      if (dispatched) deferred.reject(error);
      button.disabled = false;
      button.classList.remove('is-loading');
      const label = button.querySelector('.vayu-addon__btn-label');
      if (label) {
        label.textContent = 'Try again';
        setTimeout(() => (label.textContent = '+ Add'), 2500);
      }
    }
  });
}
